// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"418d31ae","239":"a9b26afc","453":"7fa0d74a","732":"afe1cc1e"}[chunkId] + ".chunk.js";
};